<template>
  <div class="profileInfosWrapper">
    <div class="content">
      <span class="title">{{ name }}</span>
      <div class="infos">
        <span v-if="lang === 'fr'" class="completion"
          >{{ $t("band.RPMenu.completion") }} {{ force }}% ·</span
        >
        <span v-else class="completion"
          >{{ force }}% {{ $t("band.RPMenu.completion") }} ·</span
        >
        <nuxt-link
          :to="link"
          class="profileLink"
          @click.native="$emit('close')"
        >
          {{ $t("band.RPMenu.profile") }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"

import picture_build_helper from "~/helpers/images/picture_build"

import profile_force_mixin from "~/mixins/shared/profile/force"

export default {
  mixins: [profile_force_mixin],
  computed: {
    name: function () {
      return this.kind === "band" ? this.entity.name : this.infEntityCapitalized
    },
    infEntityCapitalized: function () {
      return (
        this.entity.entity.charAt(0).toUpperCase() + this.entity.entity.slice(1)
      )
    },
    link: function () {
      return "/" + this.kind + "/profile/" + this.entity.slug + "/"
    },
    picture: function () {
      return picture_build_helper({
        kind: this.kind,
        slug: this.entity.has_profile_picture ? this.entity.slug : undefined,
        size: "200_200",
        target: "profile_picture",
      })
    },
    ...mapState({
      lang: (state) => state.locale,
    }),
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
    kind: {
      type: String,
      required: true,
    },
  },
}
</script>
<style scoped src="./profileInfos.css"></style>
